// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3524":"109b781e","6544":"482edb8a"}[chunkId] + ".chunk.css";
};